import { useState, useEffect } from "react";
import API from "../../services/api";
import { Modal, Button, Table, Form } from "react-bootstrap";

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";
const DEFAULT_IMAGE =
    BASE_URL + "/storage/branches/fNHLxMdBltb9GgL7kmZHzhym9dsPM2194SDCUAQi.jpg";

function SliderAdmin() {
    const [slides, setSlides] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);

    const [modalData, setModalData] = useState({
        id: null,
        image: null,
    });
    const [imagePreview, setImagePreview] = useState(null);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    // Fetch Slider Images
    const fetchSlides = async () => {
        try {
            const res = await API.get("/slider");
            setSlides(res.data);
        } catch (err) {
            console.error("Error loading slides:", err);
        }
    };

    useEffect(() => {
        fetchSlides();
    }, []);

    // Generate full URL
    const getImageUrl = (imgPath) =>
        imgPath ? `${BASE_URL}/storage/${imgPath}` : DEFAULT_IMAGE;

    // Handle input
    const handleChange = (e) => {
        const file = e.target.files[0];
        setModalData({ ...modalData, image: file });

        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => setImagePreview(reader.result);
            reader.readAsDataURL(file);
        }
    };

    // Submit
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setErrors({});

        try {
            const formData = new FormData();
            if (modalData.image) formData.append("image", modalData.image);

            if (isEdit) {
                await API.post(`/slider/${modalData.id}?_method=PUT`, formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                });
            } else {
                await API.post("/slider", formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                });
            }

            setShowModal(false);
            setModalData({ id: null, image: null });
            setImagePreview(null);
            fetchSlides();
        } catch (err) {
            if (err.response?.data?.errors) {
                setErrors(err.response.data.errors);
            }
        } finally {
            setLoading(false);
        }
    };

    // Delete
    const handleDelete = async (id) => {
        if (window.confirm("Delete this slider?")) {
            await API.delete(`/slider/${id}`);
            fetchSlides();
        }
    };

    return (
        <div className="container py-4">
            <div className="d-flex justify-content-between mb-3">
                <h3>📸 Slider Images</h3>
                <Button
                    onClick={() => {
                        setIsEdit(false);
                        setModalData({ id: null, image: null });
                        setImagePreview(null);
                        setShowModal(true);
                    }}
                >
                    Add Slide
                </Button>
            </div>

            <Table striped bordered hover responsive>
                <thead>
                <tr>
                    <th>Image Preview</th>
                    <th>Actions</th>
                </tr>
                </thead>
                <tbody>
                {slides.map((s) => (
                    <tr key={s.id}>
                        <td>
                            <img
                                src={getImageUrl(s.image)}
                                width="120"
                                style={{ borderRadius: "10px" }}
                                onError={(e) => (e.target.src = DEFAULT_IMAGE)}
                            />
                        </td>
                        <td>
                            <Button
                                size="sm"
                                variant="info"
                                className="me-2"
                                onClick={() => {
                                    setModalData({ id: s.id, image: s.image });
                                    setImagePreview(getImageUrl(s.image));
                                    setIsEdit(true);
                                    setShowModal(true);
                                }}
                            >
                                Edit
                            </Button>
                            <Button
                                size="sm"
                                variant="danger"
                                onClick={() => handleDelete(s.id)}
                            >
                                Delete
                            </Button>
                        </td>
                    </tr>
                ))}
                </tbody>
            </Table>

            {/* Modal */}
            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Form onSubmit={handleSubmit}>
                    <Modal.Header closeButton>
                        <Modal.Title>{isEdit ? "Update Slide" : "Add Slide"}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group>
                            <Form.Label>Image</Form.Label>
                            <Form.Control
                                type="file"
                                name="image"
                                onChange={handleChange}
                                isInvalid={!!errors.image}
                            />
                            {errors.image && (
                                <Form.Control.Feedback type="invalid">
                                    {errors.image[0]}
                                </Form.Control.Feedback>
                            )}

                            {imagePreview && (
                                <img
                                    src={imagePreview}
                                    width="150"
                                    className="mt-3 d-block"
                                    style={{ borderRadius: 10 }}
                                />
                            )}
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowModal(false)}>
                            Cancel
                        </Button>
                        <Button type="submit" variant="primary" disabled={loading}>
                            {loading ? "Saving..." : isEdit ? "Update" : "Create"}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </div>
    );
}

export default SliderAdmin;
